import React from 'react'

import {css} from '../../theme/css'
import {createSvgIcon} from '../utils'

const root = css`
  block-size: 32px;
  inline-size: 32px;
`

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_17002_365)">
      <rect fill="#E6E6E6" height="32" rx="16" width="32" />
      <g clipPath="url(#clip1_17002_365)">
        <path
          d="M-1.12109 7.12008L12.8789 2.08008L26.8789 7.12008V25.0401L12.8789 30.0801L-1.12109 25.0401V7.12008Z"
          fill="#FF7751"
        />
        <path
          d="M-1.12109 7.12012L12.8789 12.1601V30.0801L-1.12109 25.0401V7.12012Z"
          fill="#E13100"
        />
        <path
          d="M26.8789 7.12012L12.8789 12.1601V30.0801L26.8789 25.0401V7.12012Z"
          fill="#FC4714"
        />
        <path
          d="M25.3379 21.8293C22.3321 24.741 17.5105 26.4061 14.418 25.804V24.2288C17.4482 24.8469 22.3103 23.3371 25.3379 20.2542V21.8293ZM18.1406 21.8176L15.6592 22.7209V18.4954L18.1406 17.592V21.8176ZM25.0898 15.0627L24.0967 15.4241V19.6497L21.6152 20.553V16.3274L20.6221 16.6887L22.8564 10.593L25.0898 15.0627ZM19.1328 17.2297L14.666 18.8557L16.8994 12.762L19.1328 17.2297Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_17002_365">
        <rect fill="white" height="32" rx="16" width="32" />
      </clipPath>
      <clipPath id="clip1_17002_365">
        <rect
          fill="white"
          height="28"
          transform="translate(-1.12109 2.08008)"
          width="28"
        />
      </clipPath>
    </defs>
  </>,
  'DostavkaLogoCollapsed',
  {className: root, viewBox: '0 0 32 32'},
)
